module.exports = __webpack_public_path__ + "img/hgppsj.bbdc44e2.jpg";